import React from "react";

export const MenuItemLink = ({
    title,
    icon,
    disabled,
    active,
    isChild = false,
    onClick,
}) => {
    const mainClass = `${!isChild ? "menuItem" : "submenuItem"} ${
        disabled ? "disabled" : ""
    } ${active ? "active" : ""}`;

    return (
        <div
            data-testid="menu-item-link"
            className={mainClass}
            onClick={disabled ? undefined : onClick}
        >
            <span className={"menuIcon"}>{icon}</span>
            <span className={"menuLabel"}>{title}</span>
        </div>
    );
};
